module.exports = __webpack_public_path__ + "static/welcome_to_elk-0c3a1a8c6912e68b02cc38572c1c901b.png";